import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'MongoDb',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MongoDb_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.MongoDb_DisplayText)
    ]
})
export class MongoDbLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName
    })
    public serverName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number = 27017;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Authentication_Source
    })
    public authSource?: string = 'admin';

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableSSL
    })
    public enableSsl?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowSelfSignedServerCert
    })
    public allowSelfSignedServerCert?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
